import $axios from '@/axios-instance.js'

export default class UsersService {
  baseUrl = '/api/v1/admin/users'

  // static make() {
  //   return new UsersService()
  // }
  // Create
  store(params) {
    return $axios.post(this.baseUrl, params)
  }

  storeNewPassword(uuid, params) {
    return $axios.post(`${this.baseUrl}/${uuid}/password`, params)
  }

  // Read all - findAll
  index(params) {
    return $axios.get(this.baseUrl, params)
  }

  // Read one - show
  show(id, params) {
    return $axios.get(this.baseUrl + `/${id}`, params)
  }

  // Update
  update(id, params) {
    return $axios.post(this.baseUrl + `/${id}`, {
      ...params,
      _method: 'PUT',
    })
  }

  // Delete - delete
  destroy(id, params) {
    return $axios.post(this.baseUrl + `/${id}`, {
      ...params,
      _method: 'DELETE',
    })
  }
}
// UsersService.make().
export const UsersServiceInstance = new UsersService()
